import { Info } from 'lucide-react';

export interface WindowedModeBannerProps {
  pageSize: number;
}

/**
 * "Rows are streamed, editing is off" notice. Truncation-family warning, so
 * it wears the shared --energy hue rather than a one-off amber (CH-09 §6
 * item 7 — hue only, meaning unchanged). The prose stays on --foreground:
 * the energy orange is a marker hue and does not carry enough contrast
 * against its own soft wash to be body text.
 */
export function WindowedModeBanner({ pageSize }: WindowedModeBannerProps) {
  return (
    <div
      className="flex items-start gap-2 px-3 py-2 text-xs bg-energy-soft border-b border-energy text-foreground"
      role="status"
      data-testid="te-windowed-banner"
    >
      <Info className="h-4 w-4 flex-shrink-0 mt-0.5 text-energy" />
      <span>
        This page is large enough that rows are streamed on demand. Inline editing
        is unavailable. Reduce the page size (currently <strong>{pageSize.toLocaleString()}</strong>)
        to enable editing.
      </span>
    </div>
  );
}
